import { APIMethod, fetchData } from "@client";

export async function setProjectOwnerQuery(uuid, email) {
  const data = { uuid, email };
  return await fetchData("/project/owner", APIMethod.POST, { data });
}
